import React, { createContext, useContext } from 'react'

export const AppContext = createContext(null)

// The context is used to manage global data, e.g. global state, theme, services, user settings, and more
export const AppContextProvider = ({ children, appContextData }) => {
  return (
    <AppContext.Provider value={appContextData}>{children}</AppContext.Provider>
  )
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  return context
}

// eslint-disable-next-line react/display-name
export const withAppContext = (Child) => (props) =>
  (
    <AppContext.Consumer>
      {(context) => <Child {...props} appContext={context} />}
    </AppContext.Consumer>
  )

const appContext = {
  AppContextProvider,
  useAppContext,
}

export default appContext

/**
 * <------------------------------------- Example usage ----------------->
 *
 * import { useAppContext } from '../contexts/app-context' // this is just a sample. import from revelant path
 *
 * const appCtx = useAppContext()
 * const {reqContextData, pageProps} = appCtx
 */
